var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info_outline")]),
          _c("div", [
            _c("div", { class: _vm.$style.title }, [
              _vm._v(" New Company Added "),
            ]),
            _c("div", { class: _vm.$style.subTitle }, [
              _vm._v(" " + _vm._s(_vm.name) + " "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _vm._v(
            " You have just added " +
              _vm._s(_vm.name) +
              " to your company list. You can now proceed to create a new RFP or visit Company Profile. "
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              on: {
                click: function ($event) {
                  _vm.action = "manageCompany"
                },
              },
            },
            [_vm._v(" Manage Company ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v("create_new_folder"),
            ]),
            _vm._v(" Create Rfp "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }